import { withStyles, withTheme, DarkMode } from '@glu/theming';
import { FormSection } from '@glu/validation-react';
import PropTypes from 'prop-types';
import React from 'react';
import ColorInput from '../components/Color/Color';
import Fieldset from '../utility/Fieldset';

const styles = {
  root: {
    margin: 40
  }
};

const SideNavForm = ({ theme: { sideNav }, classes }) => (
  <FormSection name="sideNav">
    <DarkMode>
      <Fieldset className={classes.root} legend="Navigation Theme">
        <ColorInput
          name="color"
          labelText="Content"
          backgroundColor={sideNav.expanded.gradientStart}
        />

        <ColorInput
          name="activeLinkBackground"
          labelText="Active Link Background"
          backgroundColor={sideNav.activeLinkBackground}
        />

        <FormSection name="collapsed">
          <ColorInput
            name="gradientStart"
            labelText="Collapsed Gradient Start"
          />

          <ColorInput
            name="gradientEnd"
            labelText="Collapsed Gradient End"
          />
        </FormSection>
        <FormSection name="expanded">
          <ColorInput
            name="gradientStart"
            labelText="Expanded Gradient Start"
          />

          <ColorInput
            name="gradientEnd"
            labelText="Expanded Gradient End"
          />
        </FormSection>
      </Fieldset>
    </DarkMode>
  </FormSection>
);

SideNavForm.propTypes = {
  theme: PropTypes.shape({
    sideNav: {
      expanded: PropTypes.shape({
        gradientStart: PropTypes.string
      }),
      activeLinkBackground: PropTypes.string
    }
  }).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired
};

export default withTheme(withStyles(styles)(SideNavForm));
